"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollisionError = void 0;
/**
 * Represents a collision error ⁘
 *
 * @extends Error
 */
var CollisionError = /** @class */ (function (_super) {
    __extends(CollisionError, _super);
    function CollisionError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'CollisionError';
        return _this;
    }
    return CollisionError;
}(Error));
exports.CollisionError = CollisionError;
//# sourceMappingURL=CollisionError.js.map